import { Injectable } from "@angular/core";
import { Observable, Subject } from 'rxjs';
import { map } from "rxjs/operators";
import { Http } from "@angular/http";

@Injectable({
    providedIn: 'root'
})

export class getDocuments {
    public url;
    constructor(private _http: Http) {
      /*   console.log('Documentos'); */
    }

    getJson(): Observable<any> { return this._http.get("assets/json/docsTest.json") }
    
    getDocs() {
        return this._http.get("assets/json/docsTest.json")
            .pipe(map(res => res.json()));
    }

    getAntecedentesAdjuntan() {
        return this._http.get("assets/json/antecedentes.json")
            .pipe(map(res => res.json()));
    }

}